import { useEffect, useState, FunctionComponent } from 'react';
import { Button, IconButton, Dialog } from '../../tailwindcomponents';
import VacationApi from './../../api/vacation';
import { VacationRequest } from './../../types/vacation';
import { DatePicker } from '../../MaterialUiComponents';
import { Typography, Input, Select, SelectMultiple, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { EmployeeSearch } from '../../components';
import { Check, Clear, Search } from '../../components/icons';
import { DateRange } from '../../MaterialUiComponents/DatePicker/DatePicker';
import {vacationCategories } from './../../properties/vacationProperties';

type TimeControlVacationRequestsProps = {
  setLoading: Function;
  selectedLocation: string;
  selectedCategory: string;
  handleCategoryChange: Function;
  handleLocationChange: Function;
  setSelectedCategory: Function;
  setSelectedLocation: Function;
}

const TimeControlVacationRequests: FunctionComponent<TimeControlVacationRequestsProps> = ({ setLoading, selectedCategory, selectedLocation, handleCategoryChange, handleLocationChange, setSelectedCategory, setSelectedLocation }) => {
  const statusOptions: { name: string, id: number }[] = [{ name: 'Waiting for response', id: 1 }, { name: 'Approved', id: 2 }, { name: 'Rejected', id: 3 }];
  const [vacationRequests, setVacationRequests] = useState(Array<VacationRequest>());
  const [errorMessage, setErrorMessage] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<number[]>([1]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(0);
  const [approveRequestDialogOpen, setApproveRequestDialogOpen] = useState(false);
  const [rejectRequestDialogOpen, setRejectRequestDialogOpen] = useState(false);
  const [reopenDialogOpen, setReopenDialogOpen] = useState(false);
  const [selectedVacationRequestRow, setSelectedVacationRequestRow] = useState<VacationRequest>();
  const [timeControlReason, setTimeControlReason] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [currentRow, setCurrentRow] = useState(Array<VacationRequest>());
  const [selectedDates, setSelectedDates] = useState([new Date(), new Date()]);
  const [selectedStatusString, setSelectedStatusString] = useState("");

  const categoryList = Object.keys(vacationCategories);

  useEffect(() => {
    setLoading(true);
    refresh();
  }, [startDate, endDate, selectedStatus, selectedEmployeeId, rejectRequestDialogOpen, approveRequestDialogOpen, reopenDialogOpen, selectedLocation, selectedCategory]);

  const refresh = () => {
    const statusArray = Array<string>();
    selectedStatus.map(row => (
      statusArray.push(statusOptions.find(s => s.id === row)!.name)
    ));

    VacationApi.GetAllVacationRequest(statusArray, selectedEmployeeId, startDate, endDate, selectedCategory, selectedLocation).then(res => {
      if (res.status === true) {
        setVacationRequests(res.data);
        setErrorMessage("");
      } else {
        setVacationRequests(Array<VacationRequest>());
        setErrorMessage(res.message);
      }
      setLoading(false);
    });
  }
  const generateTableBody = (row: VacationRequest, index: number) => {
    return (
      <TableRow key={index} style={{ background: row.half_day_checked ? '#f2e54f' : undefined }}>
        <TableCell>{index}</TableCell>
        <TableCell>{row.created_date_text}</TableCell>
        <TableCell>{row.created_by_employee_name}</TableCell>
        <TableCell>{row.mechanic_reason}</TableCell>
        <TableCell>{row.vacation_from_date_string}</TableCell>
        <TableCell>{row.vacation_to_date_string}</TableCell>
        <TableCell>{row.time_control_last_modified_date_string} - {row.last_modified_by_employee_name}</TableCell>
        <TableCell>{row.status}</TableCell>
        <TableCell>{row.department_name}</TableCell>
        <TableCell>{row.time_control_reason}</TableCell>
        <TableCell>
          <div className="flex flex-wrap">
            {row.status === "Waiting for response" && <IconButton onClick={() => { setApproveRequestDialogOpen(true); setSelectedVacationRequestRow(row); }}><Check color="success" /></IconButton>}
            {row.status === "Waiting for response" && <IconButton onClick={() => { setRejectRequestDialogOpen(true); setSelectedVacationRequestRow(row); }}><Clear color="error" /></IconButton>}
          </div>
        </TableCell>
        <TableCell><Search className="cursor-pointer" onClick={() => onRowClick(row)} /></TableCell>
      </TableRow>
    )
  }
  const onSelectedEmployeeRow = (employeeId: number) => {
    setSelectedEmployeeId(employeeId);
  }
  const onTimeControlEdit = (status: boolean, timeControlAnswer: string) => {
    if (status === true) {
      VacationApi.TimeControlUpdateVacationRequest(selectedVacationRequestRow!.vacation_request_id, timeControlAnswer, timeControlReason).then(res => {
        setTimeControlReason("");
        setApproveRequestDialogOpen(false);
        setRejectRequestDialogOpen(false);
      });
    } else {
      setApproveRequestDialogOpen(false);
      setRejectRequestDialogOpen(false);
    }
  }

  const onRowClick = (row: VacationRequest) => {
    setCurrentRow([row]);
    setShowDialog(true);
  }

  const onPrintRow = () => {
    const tempVacationRequests: VacationRequest[] = vacationRequests;
    setVacationRequests([]);
    //Waiting for the state to update and clear vacation list so that the print function only prints the selected request, a little hacky but works
    //Otherwise we end up with empty pages to print.
    setTimeout(() => {
      window.print();
      setVacationRequests(tempVacationRequests);
    }, 200);
  }

  const generateTimeControlRowTableBody = (row: VacationRequest, index: number) => {
    return (
      <TableRow style={{ background: row.half_day_checked ? '#f2e54f' : undefined }}>
        <TableCell>{row.created_date_text}</TableCell>
        <TableCell>{row.created_by_employee_name}</TableCell>
        <TableCell>{row.mechanic_reason}</TableCell>
        <TableCell>{row.vacation_from_date_string}</TableCell>
        <TableCell>{row.vacation_to_date_string}</TableCell>
        <TableCell>{row.time_control_last_modified_date_string} - {row.last_modified_by_employee_name}</TableCell>
        <TableCell>{row.status}</TableCell>
        <TableCell>{row.department_name}</TableCell>
        <TableCell>{row.time_control_reason}</TableCell>
        <TableCell>{row.half_day_checked}</TableCell>
      </TableRow>
    )
  }

  const onSetSelectedDates = (dates: DateRange<Date>) => {
    if (dates[1] === null) { dates[1] = dates[0]; }
    setSelectedDates([dates[0]!, dates[1]!]);
  }

  const reopenVacationRequest = (toDate: Date, fromDate: Date, timeControlReason: string, status: string) => {
    onSetSelectedDates([toDate, fromDate]);
    setTimeControlReason(timeControlReason);
    setSelectedStatusString(status);
    setReopenDialogOpen(true);
  }

  const onTimeControlUpdateApprovedVacationRequest = (status: boolean) => {
    if (status === true) {
      VacationApi.TimeControlUpdateApprovedVacationRequest(currentRow[0].vacation_request_id, selectedStatusString, timeControlReason, selectedDates[0], selectedDates[1]).then(res => {
        setTimeControlReason("");
        setShowDialog(false);
        setReopenDialogOpen(false);
      });
    } else {
      setShowDialog(false);
      setReopenDialogOpen(false);
    }
  }

  const resetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedStatus([1]);
    setSelectedEmployeeId(0);
    setSelectedCategory("");
    setSelectedLocation("");
  }

  return (
    <div>
      <Typography text="Time Control Vacation Requests" align='center' variant='h1' />
      <div className="flex flex-wrap w-full justify-center">
        <span className="inline-block w-4 h-4 mr-1 mt-1 bg-[#f2e54f]">
        </span><span> Half day</span>
      </div>
      <div className="flex flex-wrap items-end gap-2 w-full">
        <div className="w-full sm:w-1/3 md:w-1/4 lg:w-1/12">
          <Select
            options={categoryList.map(category => category)}
            selectedItem={selectedCategory}
            widthPercentage={true}
            width={100}
            onSelectedItem={(e: React.ChangeEvent<HTMLSelectElement>) => {
              handleCategoryChange(e.target.value);
            }}
            filter_by_text="Select Unit"
          />
        </div>
        <div className="w-full sm:w-1/3 md:w-1/4 lg:w-1/12">
          <Select
            options={
              vacationCategories[selectedCategory]
                ? vacationCategories[selectedCategory].map(location => location)
                : []
            }
            selectedItem={ selectedLocation ?? ""}
            widthPercentage={true}
            width={100}
            onSelectedItem={(e: React.ChangeEvent<HTMLSelectElement>) => {
              handleLocationChange(e.target.value);
            }}
            filter_by_text="Select Work location"
          />
        </div>
        <div className="w-full sm:w-1/3 md:w-1/4 lg:w-[12.5%]">
          <EmployeeSearch place_holder={"Write employees name"} onSelectedEmployee={(employeeId: number) => onSelectedEmployeeRow(employeeId)} />
        </div>
        <div className="w-5/12 sm:w-1/4 md:w-1/6 lg:w-1/12">
          <DatePicker type="Date" selected={startDate} label="Start date" onDateChange={(date: Date) => setStartDate(date)} />
        </div>
        <div className="w-5/12 sm:w-1/4 md:w-1/6 lg:w-1/12">
          <DatePicker type="Date" selected={endDate} label="End date" onDateChange={(date: Date) => setEndDate(date)} />
        </div>
        <div className="w-full sm:w-1/3 md:w-1/4 lg:w-[12.5%]">
          <SelectMultiple optionsObject={statusOptions} selectedItems={selectedStatus} widthPercentage={true} width={100} onSelectedItem={(e: any) => setSelectedStatus(e.target.value)} filter_by_text="Status" />
        </div>
        <div className="w-5/12 sm:w-1/3 md:w-1/6">
          <Button variant="contained"  size="medium"  color='primary' onClick={() => resetFilters()}>Reset filters</Button>
        </div>
      </div>
      <Table
        headers={["Created date", "Mechanic", "Mechanic reason", "from", "to", "Time control Modified", "Status", "Work area", "Time control reason", "", "Details"]}
        rows={vacationRequests}
        generateBody={(row: any, index: number) => generateTableBody(row, index)}
        defaultRowsPerPage={5}
      />
      <br />
      {errorMessage !== "" && <Typography text={errorMessage} align='center' variant='h3' />}
      <Dialog
        visible={approveRequestDialogOpen}
        max_width={"xs"} title={"Are you sure you want to Approve"}
        context={
          <div className="w-full justify-center">
            <Input multiline={true} help_text={""} error={false} label_text={"Reason for approving request"} value={timeControlReason} onTextChange={(text: string) => setTimeControlReason(text)} type="text" width={100} />
          </div>
        }
        onClose={(status: any) => onTimeControlEdit(status, "Approved")}
        strict={false}
        show_options={true}
      />
      <Dialog
        visible={rejectRequestDialogOpen}
        max_width={"xs"} title={"Are you sure you want to Reject"}
        context={
          <div className="w-full justify-center">
            <Input multiline={true} help_text={""} error={false} label_text={"Reason for reject request"} value={timeControlReason} onTextChange={(text: string) => setTimeControlReason(text)} type="text" width={100} />
          </div>
        }
        onClose={(status: any) => onTimeControlEdit(status, "Rejected")}
        strict={false}
        show_options={true}
      />
      <Dialog
        visible={showDialog}
        max_width={"lg"}
        title={`Time Control Vacation Request for ${currentRow[0]?.created_by_employee_name}`}
        print_icon_visible={true}
        onPrint={() => onPrintRow()}
        context={
          <div>
            <div className="[zoom:75%]">
              {currentRow !== undefined &&
                <Table
                  skipIndexCol={true}
                  headers={["Created date", "Mechanic", "Mechanic reason", "from", "to", "Time control Modified", "Status", "Work area", "Time control reason"]}
                  rows={currentRow}
                  generateBody={(row: VacationRequest, index: number) => generateTimeControlRowTableBody(currentRow[0], index)}
                />
              }
            </div>
            {currentRow[0]?.status !== "Waiting for response" && <Button variant="text" onClick={() => reopenVacationRequest(currentRow[0].vacation_from_date, currentRow[0].vacation_to_date, currentRow[0].time_control_reason, currentRow[0].status)} color="primary">
              Reopen
            </Button>}
          </div>
        }
        onClose={(status: any) => setShowDialog(false)}
        strict={false}
        show_options={false}
      />
      <Dialog
        visible={reopenDialogOpen}
        max_width={"xs"}
        title={`Reopen Vacation Request for ${currentRow[0]?.created_by_employee_name}`}
        context={
          <div className="flex flex-col gap-y-8 justify-evenly">
            <div>
              <DatePicker width={100} type="DateRange" selected={null} selectedRange={[selectedDates[0], selectedDates[1]]} label="Select a date" onDateChange={(newDates: DateRange<Date>) => onSetSelectedDates(newDates)} />
            </div>
            <div>
              <Select onSelectedItem={(e: any) => setSelectedStatusString(e.target.value)} selectedItem={selectedStatusString} width={100} widthPercentage={true} filter_by_text={"Update Request Status"} options={["Approved", "Rejected"]} />
            </div>
            <div>
              <Input multiline={true} help_text={"[Optional] "} error={false} label_text={"Update comment"} value={timeControlReason} onTextChange={(text: string) => setTimeControlReason(text)} type="text" width={100} />
            </div>
          </div>
        }
        onClose={(status: boolean) => onTimeControlUpdateApprovedVacationRequest(status)}
        strict={false}
        show_options={true}
      />
    </div>
  );
}
export default TimeControlVacationRequests;